/**
 * Sync error types
 * Each type corresponds to a specific modal in constants.js
 */
export const SYNC_ERROR_TYPES = {
    // Server deadlock error → SYNC_ERROR_DIALOG
    DEADLOCK: {
        code: 'DEADLOCK'
    },
    
    // Internet reconnection → CONNECTION_RESTORED_DIALOG
    PENDING_SYNC: {
        code: 'PENDING_SYNC'
    },
    
    // Expired token (401 Unauthorized) → TOKEN_EXPIRED_DIALOG
    TOKEN_EXPIRED: {
        code: 'TOKEN_EXPIRED'
    }
};

/**
 * Error sources (entities)
 */
export const ERROR_SOURCES = {
    APPOINTMENT: 'appointment',
    VISIT: 'visit',
    DOCUMENT: 'document',
    API: 'api',
    SYSTEM: 'system'
};

/**
 * Class to create structured errors
 */
export class SyncError {
    constructor(type, source, data = {}) {
        this.id = `${source}_${type.code}_${Date.now()}`;
        this.type = type;
        this.source = source;
        this.data = data;
        this.timestamp = Date.now();
    }

    toJSON() {
        return {
            id: this.id,
            typeCode: this.type.code,
            source: this.source,
            data: this.data,
            timestamp: this.timestamp
        };
    }
}
